// 9fbef606107a605d69c0edbcd8029e5d
import LOYALTY_PLACE_REWARDS_CONSTANTS from '@tcp/core/src/components/features/account/PlaceRewards/LoyaltyPlaceRewards.constants';

export const redeemLoyaltyPoints = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.REDEEM_LOYALTY_POINTS,
  payload,
});

export const clearAPIErrors = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.CLEAR_API_ERRORS,
  payload,
});

export const setIsPointsRedemptionInProgress = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.SET_POINTS_REDEMPTION_IN_PROGRESS,
  payload,
});

export const setRedeemAPIError = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.REDEEM_API_ERROR,
  payload,
});

export const setPointsToRedeem = (payload) => ({
  type: LOYALTY_PLACE_REWARDS_CONSTANTS?.POINTS_TO_REDEEM,
  payload,
});

export default setIsPointsRedemptionInProgress;
